export const BUTTON_MESSAGES = {
	DELETE: "Excluir",
	EDIT: "Editar",
	ADD: "Adicionar"
};